import { Check } from 'almanac-ui/icons/16'
import { ButtonProps } from 'components/Button/Types'
import { ReactElement, ReactNode } from 'react'
import { InlineFormatButton } from '../InlineFormatButton/InlineFormatButton'
import Styles from './InlineFormatDropdownMenuItem.module.scss'

export interface InlineFormatDropdownMenuItemProps extends ButtonProps {
  key?: string
  active?: boolean
  icon: ReactElement
  label: ReactNode
  rightContent?: ReactNode
  onHoverStart?: () => void
  onHoverEnd?: () => void
}

export const InlineFormatDropdownMenuItem = ({
  active,
  isDisabled = false,
  icon,
  label,
  rightContent,
  ...props
}: InlineFormatDropdownMenuItemProps) => {
  return (
    <InlineFormatButton
      size="md"
      active={active}
      isDisabled={isDisabled}
      className={Styles.InlineFormatDropdownMenuItem}
      data-testid={typeof label === 'string' ? label : undefined}
      {...props}
    >
      <div className={Styles.content}>
        {icon}
        {label}
      </div>
      {rightContent}
      {!rightContent && active && <Check />}
    </InlineFormatButton>
  )
}
